import { IApplicationState } from '../../types/redux';

export function getNewBuildingById(state: IApplicationState, id: number) {
  return state.newBuildings.data.hash[id];
}
